import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  showUpdate,
  limpa,
  showIntervalo,
  getList,
  create,
  setPaginaAtual,
  sincronizarConfiguracaoCompleta,
  getTabelasTrocaPlano,
  excluirTabelasTroca,
} from './planoActions';
import { getListInterval, update, getListTodosPlanosPorAnel } from '../intervalo/intervaloActions';
import SPButton from '../common/form/spButton';
import ButtonTooltip from '../common/form/buttonTooltip';
import PremiumTableShell from '../common/grid/premiumTableShell';

import ReactTableGT2A from '../common/grid/gridReactTable';
import '../common/grid/grid.css';
import swal from 'sweetalert2';
import { toastr } from 'react-redux-toastr';
import { Modal } from 'react-bootstrap';
import ReactLoading from 'react-loading';
import PermissaoUsuario from '../auth/permissao';
import { getConfig } from '../configuracao/configLocal';
import { lerAneis } from '../controlador/controladorActions';
import If from '../common/operator/if';
import html2canvas from 'html2canvas';

class PlanoList extends Component {
  constructor(props) {
    super(props);

    this.intervalGetList = 0;
    this.semaphoreIntervalId = null;
    this.componentRef = React.createRef();

    this.limparPlano = this.limparPlano.bind(this);
    this.alterarPlano = this.alterarPlano.bind(this);
    this.configurarPlano = this.configurarPlano.bind(this);
    this.lerPlanoControlador = this.lerPlanoControlador.bind(this);
    this.salvarPlanoDB = this.salvarPlanoDB.bind(this);
    this.lerPlanoSistema = this.lerPlanoSistema.bind(this);

    this.modOperacaoDesc = [
      'Isolado/Normal',
      'Isolado/Atuado',
      'Isolado Atuado com Sequência Lógica',
      'Sincronizado/Normal',
      'Sincronizado/Atuado',
      'Sincronizado Atuado com Sequência Lógica',
      'Adaptativo Local',
      'Adaptativo Sincronizado',
    ];

    this.state = {
      show: false,
      planoList: [],
      intervaloList: [],
      salvarDB: false,
      modalAnel: '',
      semaphoreActiveIndex: 0,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.show && !prevState.show) {
      this.semaphoreIntervalId = setInterval(() => {
        this.setState(prev => ({ semaphoreActiveIndex: (prev.semaphoreActiveIndex + 1) % 3 }));
      }, 3000);
    } else if (!this.state.show && prevState.show) {
      clearInterval(this.semaphoreIntervalId);
      this.semaphoreIntervalId = null;
    }
  }

  componentWillUnmount() {
    if (this.semaphoreIntervalId) {
      clearInterval(this.semaphoreIntervalId);
    }
  }

  handlePageChange = page => {
    this.props.setPaginaAtual(page);
  };

  async salvarPlanoDB() {
    if (!this.state.planoList || this.state.planoList.length === 0) {
      toastr.warning('Atenção', 'Não há dados de planos lidos do controlador para salvar.');
      return;
    }

    // 1. Agrupar todos os planos pelo seu ID de anel (controlador_id)
    const planosAgrupadosPorAnel = this.state.planoList.reduce(
      (acc, plano) => {
        const anelId = plano.controlador_id;
        if (!anelId) {
          console.error('Plano sem controlador_id válido encontrado:', plano);
          toastr.error('Erro de Dados', `Plano ${plano.id} (Anel ${plano.anel}) está sem ID de controlador.`);
          acc.hasError = true;
          return acc;
        }
        if (!acc[anelId]) {
          acc[anelId] = [];
        }
        acc[anelId].push(plano);
        return acc;
      },
      { hasError: false },
    );

    if (planosAgrupadosPorAnel.hasError) {
      toastr.error('Erro', 'Alguns planos não puderam ser agrupados. Verifique o console.');
      return;
    }
    delete planosAgrupadosPorAnel.hasError;

    // 2. Formatar os dados para cada anel no payload esperado pela API
    const configuracoesPorAnel = Object.keys(planosAgrupadosPorAnel).map(anelId => {
      const planosDoAnel = planosAgrupadosPorAnel[anelId];
      return {
        controlador_id: anelId.toString(),
        planos: planosDoAnel.map(plano => ({
          plano_id_controlador: plano.id,
          descricao: plano.descricao,
          status: plano.status === undefined ? 1 : plano.status,
          modo_operacao_id: plano.modo_operacao_id,
          numero_intervalo: plano.numero_intervalo,
          ciclo_maximo: plano.ciclo_maximo,
          defasagem: plano.defasagem,
          atuado_var: plano.atuador_var,
          intervalos: plano.intervalos,
        })),
      };
    });

    if (configuracoesPorAnel.length === 0) {
      toastr.warning('Atenção', 'Não foi possível formatar nenhuma configuração para salvar.');
      return;
    }

    // 3. Confirmar com o usuário
    const result = await swal({
      title: 'Salvar as novas configurações?',
      html: `<h5>Toda a configuração de planos para os anéis lidos será substituída.</h5> <h5><strong>Esta ação não pode ser desfeita!</strong></h5>`,
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, sincronizar',
      cancelButtonText: 'Cancelar',
      allowOutsideClick: false,
    });

    if (result.value) {
      // 4. Chamar a nova action orquestradora
      this.setState({
        show: true,
        modalAnel: `Sincronizando ${
          configuracoesPorAnel.length
        } anel(éis)... <br> <small>Aguarde, este processo pode levar algum tempo.</small>`,
      });

      try {
        // Capturar imagem da tela antes de enviar
        const canvas = await html2canvas(this.componentRef.current);
        const image = canvas.toDataURL('png');

        // Adicionar imagem a todas as configurações
        const configuracoesPorAnelComImagem = configuracoesPorAnel.map(config => ({
          ...config,
          imageLog: image,
        }));

        await this.props.sincronizarConfiguracaoCompleta(configuracoesPorAnelComImagem);
        // A action interna já mostra o toastr de sucesso/erro
        this.lerPlanoSistema(); // Atualiza a lista da tela
      } catch (error) {
        // A action já trata o erro, mas podemos logar se quisermos
        console.error('Falha geral no processo de sincronização:', error);
      } finally {
        this.setState({ show: false, modalAnel: '' });
      }
    }
  }

  lerPlanoSistema() {
    this.setState({ planoList: [], salvarDB: false });
    this.props.getList();
  }

  async lerPlanoControlador() {
    this.setState({ show: true, planoList: [], salvarDB: false, modalAnel: 'Carregando informações dos anéis...' });
    const numCont = getConfig('numCont');
    const grupo = getConfig('grupo');
    let todosOsPlanosColetados = [];
    const resumoLeitura = { lidos: [], vazios: [], erros: [] };

    try {
      const respostaAneis = await this.props.lerAneis(numCont, grupo, true);
      const aneis =
        (respostaAneis && respostaAneis.data) ||
        (respostaAneis && respostaAneis.payload && respostaAneis.payload.data) ||
        this.props.aneis ||
        [];

      if (!aneis || aneis.length === 0) {
        toastr.error('Erro', 'Nenhum anel encontrado para este controlador.');
        this.setState({ show: false, modalAnel: '' });
        return;
      }
      for (const anelInfo of aneis) {
        this.setState({
          modalAnel: `Lendo todos os planos do Anel ${
            anelInfo.anel
          } <br /> <small>Aguarde, esse processo pode levar algum tempo</small>`,
        });
        try {
          const resultadoAnel = await this.props.getListTodosPlanosPorAnel(anelInfo.anel, numCont, grupo);
          const respostaAnel =
            (resultadoAnel && resultadoAnel.payload && resultadoAnel.payload.data) ||
            (resultadoAnel && resultadoAnel.data) ||
            null;

          if (respostaAnel && respostaAnel.success) {
            const planosDoAnel = respostaAnel.data;
            if (planosDoAnel.length > 0) {
              resumoLeitura.lidos.push(anelInfo.anel);
              const planosFormatadosParaLista = planosDoAnel.map(planoBackend => ({
                anel: planoBackend.anel,
                controlador_id: planoBackend.controlador_id,
                id: planoBackend.plano_id_controlador,
                descricao: planoBackend.descricao,
                status: 1,
                modo_operacao_id: planoBackend.modo_operacao_id,
                modo_operacao_desc: this.modOperacaoDesc[planoBackend.modo_operacao_id],
                numero_intervalo: planoBackend.numero_intervalo,
                ciclo_maximo: planoBackend.ciclo_maximo,
                defasagem: planoBackend.defasagem,
                atuador_var: planoBackend.atuado_var,
                intervalos: planoBackend.intervalos,
                tempo_vermelho_min: planoBackend.tempo_vermelho_min_controlador,
                tempo_amarelo_min: planoBackend.tempo_amarelo_min_controlador,
                tempo_verde_min: planoBackend.tempo_verde_min_controlador,
                fase_conflitante: planoBackend.fases_conflitantes_controlador,
              }));
              todosOsPlanosColetados = [...todosOsPlanosColetados, ...planosFormatadosParaLista];
              this.setState({ planoList: [...todosOsPlanosColetados], salvarDB: true });
            } else {
              resumoLeitura.vazios.push(anelInfo.anel);
            }
          } else {
            const errorMsg =
              (resultadoAnel &&
                resultadoAnel.response &&
                resultadoAnel.response.data &&
                resultadoAnel.response.data.errors &&
                resultadoAnel.response.data.errors[0]) ||
              (resultadoAnel &&
                resultadoAnel.payload &&
                resultadoAnel.payload.response &&
                resultadoAnel.payload.response.data.errors &&
                resultadoAnel.payload.response.data.errors[0]) ||
              `Erro ao ler planos do Anel ${anelInfo.anel}.`;
            resumoLeitura.erros.push({ anel: anelInfo.anel, mensagem: errorMsg });
          }
        } catch (e) {
          console.error(`Falha ao requisitar planos para o Anel ${anelInfo.anel}:`, e);
          resumoLeitura.erros.push({
            anel: anelInfo.anel,
            mensagem: `Falha na comunicação ao buscar planos do Anel ${anelInfo.anel}.`,
          });
        }
      }

      if (resumoLeitura.lidos.length > 0) {
        const aneisLidos = resumoLeitura.lidos.join(', ');
        toastr.success(
          'Sucesso',
          `${todosOsPlanosColetados.length} plano(s) lido(s) com sucesso nos anéis: ${aneisLidos}.`,
        );
      }
      if (resumoLeitura.vazios.length > 0 && resumoLeitura.lidos.length === 0) {
        toastr.info('Atenção', `Nenhum plano configurado foi encontrado nos anéis: ${resumoLeitura.vazios.join(', ')}.`);
      }
      if (resumoLeitura.erros.length > 0) {
        const detalhes = resumoLeitura.erros.map(e => `Anel ${e.anel}: ${e.mensagem}`).join(' | ');
        toastr.error('Erro', detalhes);
      }
    } catch (error) {
      console.error('Falha geral ao ler anéis do controlador:', error);
      toastr.error('Erro', 'Não foi possível carregar a lista de anéis do controlador.');
    } finally {
      this.setState({ show: false, modalAnel: '' });
    }
  }

  async getPlano(cont, plano, anel, numCont, grupo) {
    return new Promise(resolve => {
      this.props
        .getListInterval(plano, anel, numCont, grupo)
        .then(result => {
          if (!result.error) {
            toastr.success('Sucesso', 'Plano ' + plano + ' lido com sucesso.');
            resolve(result.payload.data);
          } else {
            toastr.error('Erro', result.payload.response.data.errors[0]);
            resolve(false);
          }
        })
        .catch(e => {
          resolve(false);
          toastr.info('Atenção', 'Plano ' + plano + ' não encontrado!');
        });
    });
  }

  async limparPlano(data) {
    if (!this.state.salvarDB) {
      try {
        // Buscar tabelas de troca vinculadas ao plano
        const resultTabelasTroca = await this.props.getTabelasTrocaPlano(data.id);
        const tabelasTroca = resultTabelasTroca.payload.data || [];

        if (tabelasTroca.length > 0) {
          // Existe tabela de troca vinculada - mostrar modal específico
          const tabelasInfo = tabelasTroca.map(t => `${t.id} (${t.horario_inicial})`).join(', ');

          swal({
            title: 'Plano possui Tabela de Troca vinculada',
            html: `<p><strong>Esse plano possui a(s) tabela(s) de troca ${tabelasInfo} vinculada(s) a ele.</strong></p>
                   <p><strong>Esta exclusão removerá o plano e a(s) tabela(s) de troca.</strong></p>
                   <p><strong>Deseja continuar?</strong></p>`,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Sim, excluir tudo',
            cancelButtonText: 'Cancelar',
            allowOutsideClick: false,
            width: '600px',
          }).then(async result => {
            if (result.value) {
              // Mostrar loading
              this.setState({
                show: true,
                modalAnel: 'Excluindo plano e tabelas de troca...',
              });

              try {
                // Excluir tabelas de troca primeiro
                const idsTabelas = tabelasTroca.map(t => t.id);
                const resultExclusaoTabelas = await this.props.excluirTabelasTroca(idsTabelas);

                if (resultExclusaoTabelas.success) {
                  // Depois excluir o plano
                  await this.props.limpa(data);
                } else {
                  toastr.error('Erro', 'Falha ao excluir tabelas de troca. O plano não foi excluído.');
                }
              } catch (error) {
                console.error('Erro durante exclusão:', error);
                toastr.error('Erro', 'Falha durante o processo de exclusão.');
              } finally {
                // Esconder loading
                this.setState({ show: false });
              }
            }
          });
        } else {
          // Não existe tabela de troca - modal normal
          swal({
            title: 'Deseja realmente excluir do sistema e do controlador?',
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: 'primary',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
            allowOutsideClick: false,
          }).then(async result => {
            if (result.value) {
              // Mostrar loading
              this.setState({
                show: true,
                modalAnel: 'Excluindo plano do sistema e controlador...',
              });

              try {
                await this.props.limpa(data);
              } catch (error) {
                console.error('Erro durante exclusão:', error);
                toastr.error('Erro', 'Falha durante o processo de exclusão.');
              } finally {
                // Esconder loading
                this.setState({ show: false });
              }
            }
          });
        }
      } catch (error) {
        console.error('Erro ao verificar tabelas de troca:', error);
        toastr.error('Erro', 'Falha ao verificar tabelas de troca vinculadas ao plano.');
      }
    } else {
      toastr.warning(
        'Alerta',
        `Não é permitido exclusão sem antes salvar no sistema. Clique no botão "Salvar no sistema" primeiro`,
      );
    }
  }

  alterarPlano(data) {
    if (!this.state.salvarDB) {
      this.props.showUpdate(data);
    } else {
      toastr.warning(
        'Alerta',
        `Não é permitido alteração sem antes salvar no sistema. Clique no botão "Salvar no sistema" primeiro`,
      );
    }
  }

  configurarPlano(data) {
    if (!this.state.salvarDB) {
      setTimeout(() => {
        if (this.props.permiteAlterarPagina) {
          this.props.permiteAlterarPagina(false);
        }

        window
          .$('#selectConfControlador')
          .val(data.controlador_id)
          .get(0)
          .dispatchEvent(new Event('change', { bubbles: true }));
        this.props.showIntervalo(data);

        if (this.props.permiteAlterarPagina) {
          this.props.permiteAlterarPagina(true);
        }
      }, 0);
    } else {
      toastr.warning(
        'Alerta',
        `Não é permitido configurar plano sem antes salvar no sistema. Clique no botão "Salvar no sistema" primeiro`,
      );
    }
  }

  render() {
    const planoDB = this.props.list;
    let plano = this.state.planoList;
    const paginaAtual = this.props.paginaAtual;
    if (plano.length === 0) {
      plano = planoDB || [];
    }

    const columns = [
      {
        Header: 'Ações',
        Cell: row => (
          <div className="plano-actions-cell">
            <PermissaoUsuario tela="CadPlano" condicao={true}>
              <div className="plano-actions-group">
                <SPButton
                  type="button"
                  className="success btn-sm"
                  icon="cog"
                  data-title="Configurar Plano"
                  onClick={() => this.configurarPlano(row.original)}
                />
                <SPButton
                  type="button"
                  className="warning btn-sm"
                  icon="pencil-alt"
                  data-title="Alterar"
                  onClick={() => this.alterarPlano(row.original)}
                />
                <SPButton
                  type="button"
                  className="danger btn-sm"
                  icon="trash-alt"
                  data-title="Excluir e Limpar do Controlador"
                  onClick={() => this.limparPlano(row.original)}
                  disabled={row.original.id !== row.original.ultimo_plano}
                />
              </div>
            </PermissaoUsuario>
            <PermissaoUsuario tela="CadPlano" condicao={false}>
              <div className="plano-actions-group">
                <SPButton
                  type="button"
                  className="success btn-sm"
                  icon="cog"
                  data-title="Configurar Plano"
                  onClick={() => this.configurarPlano(row.original)}
                />
                <SPButton type="button" className="warning btn-sm" icon="pencil-alt" disabled="disabled" />
                <SPButton
                  type="button"
                  className="danger btn-sm"
                  icon="trash-alt"
                  data-title="Excluir e Limpar do Controlador"
                  disabled="disabled"
                />
              </div>
            </PermissaoUsuario>
          </div>
        ),
        width: 120,
        filterable: true,
        resizable: true,
        className: 'column_icon',
        Filter: () => (
          <div className="rt-th">
            <span>Filtrar</span>
          </div>
        ),
      },
      {
        Header: 'Plano',
        accessor: 'id',
        width: 70,
        className: 'column_grid column_center',
        filterable: true,
        resizable: true,
      },
      {
        Header: 'Anel',
        accessor: 'anel',
        width: 70,
        className: 'column_grid column_center',
        filterable: true,
        resizable: true,
      },
      {
        Header: 'Descrição',
        accessor: 'descricao',
        width: 360,
        className: 'column_grid column_left',
        filterable: true,
        resizable: true,
      },
      {
        Header: 'Operação',
        className: 'column_grid column_left',
        accessor: 'modo_operacao_desc',
        width: 380,
        resizable: true,
      },
      {
        Header: 'Intervalos',
        accessor: 'numero_intervalo',
        className: 'column_grid column_center',
        width: 120,
        resizable: true,
      },
    ];

    const lightsConfig = [
      { color: '#28a745', key: 'green' },
      { color: '#fd7e14', key: 'orange' },
      { color: '#dc3545', key: 'red' },
    ];

    const semaphoreStyles = {
      overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0,0,0,0.3)',
        zIndex: 2000,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        paddingTop: '15vh',
        animation: 'fadeInOverlayPlanoList 0.3s ease-out',
      },
      modal: {
        background: 'rgb(255, 255, 255)',
        border: '1px solid rgba(255,255,255,0.3)',
        backdropFilter: 'blur(8px)',
        borderRadius: '16px',
        padding: '2rem 3.5rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        animation: 'popUpModalPlanoList 0.3s ease-out',
        boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
      },
      semaphoreContainer: { display: 'flex', gap: '12px', marginBottom: '1.5rem' },
      light: {
        width: '20px',
        height: '20px',
        borderRadius: '50%',
        border: '2px solid rgba(0,0,0,0.08)',
        transition: 'opacity 0.4s ease-in-out, transform 0.4s ease-in-out',
      },
      message: {
        marginTop: '1rem',
        color: 'rgb(50, 50, 50)',
        fontSize: '1.4rem',
        textAlign: 'center',
        maxWidth: '250px',
        lineHeight: '1.4',
      },
    };

    const renderOverlay = () => {
      if (!this.state.show) return null;
      return (
        <div style={semaphoreStyles.overlay}>
          <div style={semaphoreStyles.modal}>
            <div style={semaphoreStyles.semaphoreContainer}>
              {lightsConfig.map((light, index) => (
                <div
                  key={light.key}
                  style={{
                    ...semaphoreStyles.light,
                    backgroundColor: light.color,
                    opacity: index === this.state.semaphoreActiveIndex ? 1 : 0.25,
                    transform: index === this.state.semaphoreActiveIndex ? 'scale(1.12)' : 'scale(1)',
                    animation:
                      index === this.state.semaphoreActiveIndex ? 'pulsePlanoList 1.5s infinite alternate' : 'none',
                  }}
                />
              ))}
            </div>
            <div style={semaphoreStyles.message} dangerouslySetInnerHTML={{ __html: this.state.modalAnel }} />
          </div>
          <style>{`
                    @keyframes popUpModalPlanoList { 
                        0% { transform: translateY(-25px) scale(0.9); opacity: 0; } 
                        100% { transform: translateY(0) scale(1); opacity: 1; } 
                    }
                    @keyframes fadeInOverlayPlanoList { 
                        from { opacity: 0; } 
                        to { opacity: 1; } 
                    }
                    @keyframes pulsePlanoList {
                        0% { opacity: 1; transform: scale(1.12); }
                        50% { opacity: 0.6; transform: scale(1.05); }
                        100% { opacity: 1; transform: scale(1.12); }
                    }
                `}</style>
        </div>
      );
    };

    return (
      <div ref={this.componentRef}>
        {renderOverlay()}
        <style>{`
          .plano-actions-cell {
            display: flex;
            justify-content: center;
            width: 100%;
          }

          .plano-actions-group {
            display: inline-flex;
            align-items: center;
            gap: 4px;
            padding: 2px;
          }

          .plano-actions-group .btn {
            border-radius: 9px !important;
            min-width: 28px;
            width: 28px;
            height: 28px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            border: 0 !important;
            box-shadow: none !important;
            padding: 0 !important;
            font-size: 12px !important;
          }

          .plano-actions-group .btn.success {
            background: linear-gradient(135deg, #34d399 0%, #10b981 100%) !important;
            color: #ffffff !important;
          }

          .plano-actions-group .btn.warning {
            background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%) !important;
            color: #ffffff !important;
          }

          .plano-actions-group .btn.danger {
            background: linear-gradient(135deg, #f87171 0%, #ef4444 100%) !important;
            color: #ffffff !important;
          }

          .plano-footer-actions {
            display: flex;
            align-items: center;
            gap: 12px;
            flex-wrap: wrap;
            padding: 4px 2px 0;
          }

          .plano-footer-actions .btn {
            border-radius: 12px !important;
            min-height: 40px;
            padding: 0 16px !important;
            border: 0 !important;
            font-weight: 600;
            box-shadow: 0 10px 20px rgba(15, 23, 42, 0.08) !important;
          }

          .plano-footer-actions .btn.success {
            background: linear-gradient(135deg, #5fa8d3 0%, #3d8ec3 100%) !important;
            color: #ffffff !important;
          }
          .plano-footer-actions .btn.primary {
            background: linear-gradient(135deg, #4f8fb8 0%, #2f6f98 100%) !important;
            color: #ffffff !important;
          }

          .plano-premium-table .ReactTable .rt-th.column_left,
          .plano-premium-table .ReactTable .rt-td.column_left {
            justify-content: flex-start;
            text-align: left;
          }

          .plano-premium-table .ReactTable .rt-th.column_left .rt-resizable-header-content,
          .plano-premium-table .ReactTable .rt-th.column_left .rt-th-content {
            width: 100%;
            text-align: left;
            justify-content: flex-start;
          }

          .plano-premium-table .ReactTable .rt-th.column_center,
          .plano-premium-table .ReactTable .rt-td.column_center,
          .plano-premium-table .ReactTable .rt-th.column_icon,
          .plano-premium-table .ReactTable .rt-td.column_icon {
            justify-content: center;
            text-align: center;
          }
        `}</style>
        <div className="plano-premium-table">
          <PremiumTableShell summary={`${plano.length} plano(s) carregado(s)`} tableMinWidth={1120}>
            <ReactTableGT2A
              data={plano}
              columns={columns}
              showFilters={false}
              className="-striped -highlight"
              defaultPageSize={15}
              minRows={0}
              onPageChange={this.handlePageChange}
              page={paginaAtual}
            />
          </PremiumTableShell>
        </div>

        <div className="plano-footer-actions">
          <PermissaoUsuario tela="CadIntervaloPlano" campo="ler_controlador" condicao={true}>
            <ButtonTooltip
              type="button"
              id="btnLerControlador"
              className="success"
              icon="download"
              label="Ler Controlador"
              data-title="Busca os dados do controlador"
              onClick={this.lerPlanoControlador}
            />
          </PermissaoUsuario>

          <If condicao={this.state.salvarDB}>
            <PermissaoUsuario tela="CadPlano" condicao={true}>
              <ButtonTooltip
                type="button"
                id="btnDataPlanoSalvarDB"
                className="primary"
                icon="check"
                label="Salvar no sistema"
                data-title="Salva no sistema os dados que vieram do controlador"
                onClick={this.salvarPlanoDB}
              />
            </PermissaoUsuario>
            <PermissaoUsuario tela="CadPlano" condicao={false}>
              <ButtonTooltip
                type="button"
                id="btnDataPlanoSalvarDB"
                className="primary"
                icon="check"
                label="Salvar no sistema"
                disabled="disabled"
              />
            </PermissaoUsuario>
          </If>
          <If condicao={this.state.salvarDB}>
            <PermissaoUsuario tela="CadPlano" condicao={true}>
              <ButtonTooltip
                type="button"
                id="btnPlanoLerSistema"
                className="primary"
                icon="file-download"
                label="Ler do sistema"
                data-title="Busca os dados do banco de dados do sistema"
                onClick={this.lerPlanoSistema}
              />
            </PermissaoUsuario>
            <PermissaoUsuario tela="CadPlano" condicao={false}>
              <ButtonTooltip
                type="button"
                id="btnPlanoLerSistema"
                className="primary"
                icon="file-download"
                label="Ler do sistema"
                disabled="disabled"
              />
            </PermissaoUsuario>
          </If>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  list: state.planoCad.list,
  aneis: state.controladorCad.aneis,
  paginaAtual: state.planoCad.paginaAtual,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      showUpdate,
      limpa,
      showIntervalo,
      getList,
      getListInterval,
      getListTodosPlanosPorAnel,
      create,
      update,
      lerAneis,
      setPaginaAtual,
      sincronizarConfiguracaoCompleta,
      getTabelasTrocaPlano,
      excluirTabelasTroca,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PlanoList);
